var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"top"}},[_c('Row',[_c('Col',{staticStyle:{"text-align":"left"},attrs:{"span":"4"}},[_vm._t("left")],2),_vm._v(" "),_c('Col',{attrs:{"span":"16"}},[_vm._t("center")],2),_vm._v(" "),_c('Col',{staticStyle:{"text-align":"right"},attrs:{"span":"4"}},[_vm._t("right")],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67398f7c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/top.vue
// module id = null
// module chunks = 